<template>
	<v-row>
		<v-col cols="12" md="8">
			<v-list>
				<v-list-item-group v-model="selected" multiple>
					<v-list-item
						dense
						:value="Number(value)"
						:key="key"
						v-for="[key, value] in Object.entries($store.getters.getPermisos).sort(( [,v1], [,v2] ) => v1 > v2 ? 1 : -1)"
					>
						<template v-slot:default="{ active }">
							<v-list-item-action>
								<v-checkbox :input-value="active"></v-checkbox>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>{{ key }}</v-list-item-title>
								<v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
							</v-list-item-content>
						</template>
					</v-list-item>
				</v-list-item-group>
			</v-list>
			<v-divider></v-divider>
			{{ total }}
		</v-col>

		<v-col cols="12" md="4">
				<v-subheader>Colors</v-subheader>
				<v-card class="pa-3">
					<!-- <div class="d-flex justify-space-around" v-for="(subPallete, i) in pallete" > -->
					<v-avatar v-for="(color, k) in pallete" :key="k" :color="color" size="35" class="ma-1" tile>{{ k }}</v-avatar>
					<!-- </div> -->
				</v-card>
			</v-col>
		<v-col cols="12" md="12">
				<v-subheader>Icons</v-subheader>
				<v-card class="pa-3">
					<v-autocomplete
						v-model="iconSelected"
						:items="icons"
						filled
						hide-details
						prepend-inner-icon="mdi-magnify"
						clearable
						:item-text="i => 'asjdhf'"
					>

					<template v-slot:item="{item}">
						<v-icon left>{{ item }}</v-icon>
						{{ item }}
					</template>

					</v-autocomplete>

					<v-icon x-large class="mt-2">{{ iconSelected }}</v-icon>
					<!-- <div class="d-flex justify-space-around" v-for="(subPallete, i) in pallete" > -->
					<!-- <v-icon v-for="(icon, k) in icons" :key="k" size="35" class="ma-1" tile>{{ icon }}</v-icon> -->
					<!-- </div> -->
				</v-card>
			</v-col>
	</v-row>
</template>

<script>
import pallete from '@/utils/colorPallete.js'
import * as icons from '@mdi/js'

export default {
	data() {
		return {
			pallete,
			selected: [],
			iconSelected: null,
			icons : Object.keys( icons ).map( string => string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase() )
		}
	},
	computed: {
		total() {
			return this.selected.reduce( ( t, a ) => t + a, 0 )
		}
	},
	mounted() {
		// console.log(this.icons);
	}
}
</script>

<style>
</style>